import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import StyleTwoSectionTitle from './StyleTwoSectionTitle'
import StyleTwoClassTabs from './StyleTwoClassTabs'

export class StyleTwoTabsClass extends Component {
  static propTypes = {
    styleTwo: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    tabsList: {},
    defaultIndex: 1,
  }
  componentWillMount(){
    this.setState({
      tabsList: this.props.itemsData
    });
  }
  toggleTabs(id) {
    let { tabsList } = this.state;
    tabsList.list.map(item => {
      if (item.id === id) {
        item.active = true;
      } else {
        item.active = false;
      }
    })
    this.setState({ tabsList, defaultIndex: id });
  }

  render() {
    let { tabsList, defaultIndex } = this.state;
    let { onMeiQiaCustomer, colorData } = this.props;
    console.log(tabsList);
    return (
      <div className="style-two-style-two-tabs-class" style={{ background: `url(${tabsList.totalbackImg}) no-repeat`}}>
        <div className='class_container'>
          <a name={tabsList.name}><StyleTwoSectionTitle Data={tabsList} isColorW={false} /></a>
          <div className='system_section'>
            <div className='system_list'>
              <StyleTwoClassTabs list={tabsList.list[defaultIndex - 1].itemsData} colorData={colorData} listId={tabsList.list[defaultIndex - 1].id} onMeiQiaCustomer={onMeiQiaCustomer} />
            </div>
            <div className='system_tabs'>
              {tabsList.list && tabsList.list.map(item => <div className={item.active ? 'tabs_item active' : 'tabs_item'} key={item.id} onClick={this.toggleTabs.bind(this, item.id)}>
                {item.title}
              </div>)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    styleTwo: state.styleTwo,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoTabsClass);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoTabsClass.js